var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divContactUsWrapper"}},[_c('VueWrapperNarrow',{staticClass:"wrapper-narrow"},[_c('div',{staticClass:"co-wrapper",domProps:{"innerHTML":_vm._s(_vm.content)}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }